<div
  *ngFor="let cat of categories"
  class="badge badge-pill"
  [ngClass]="cat.rating < 4 ? 'badge-secondary-danger' : 'badge-secondary-success'"
  [matTooltip]="'Rating: ' + cat.channelRating + '/' + (getMaxRating | call : review)"
>
  {{ cat.category | reviewCategory }}
</div>
